import React from "react";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
import Check from "@material-ui/icons/Check";
import Warning from "@material-ui/icons/Warning";
// core components
import SnackbarContent from "components/Snackbar/SnackbarContent.js";
import Clearfix from "components/Clearfix/Clearfix.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import notificationsStyles from "assets/jss/material-kit-pro-react/views/componentsSections/notificationsStyles.js";

const useStyles = makeStyles(notificationsStyles);

export default function aboutCompany() {
  const classes = useStyles();
  return (
    <div className={classes.container + " cd-section"} id="aboutCompany">
      {/* <div className={classes.space70} /> */}
      <div className={classes.title}>
        <h3>About the Company</h3>
      </div>
      <GridContainer>
        <GridItem md={6}>
          <p>
            Business Type
            <br />
            Trading Company
          </p>
        </GridItem>
        <GridItem md={6}>
          <p>
            Employee Count
            <br />
            10
          </p>
        </GridItem>
        <GridItem md={6}>
          <p>
            Establishment
            <br />
            2005
          </p>
        </GridItem>
        <GridItem md={6}>
          <p>
            Working Days
            <br />
            Monday To Saturday
          </p>
        </GridItem>
        <GridItem md={6}>
          <p>
            GST
            <br />
            27BIHPS1545J1ZX
          </p>
        </GridItem>
        <GridItem md={6}>
          <p>
            Exports to
            <br />
            INDIA | US | SAUDI ARABIA | MEXICO | BANGLADESH
          </p>
        </GridItem>
        <GridItem md={12}>
          <p>
            Established in the year 2008, inshabangles.com is India's leading
            destination for high-quality Brass Bangles with strikingly beautiful
            designs. We excel in manufacturing and exporting various types of
            bangles, Earrings, Finger rings, Sikh Kada, Lamina do Watches, and
            more. We aim to revolutionize the fine bangles and lifestyle segment
            in India with a firm focus on craftsmanship, quality, and customer
            experience. We house more than 1,500 unique designs for you to
            choose from. All these designs are crafted to perfection with
            high-quality plated colours to suit the client’s needs. Our
            manufacturing operation consists of 11 deliberate units spread over
            3600 sq. ft. in Karnataka, employing a dedicated workforce of over
            200 workers having a personal production capacity of 12,00,000
            pieces per annum. With the standard product development team for the
            perfect quality guarantee, & market research and development
            designed for us to be modernized as per international standards. We
            are strongly focused on market expansion, having a track record of
            developing contemporary designs that cater to a client's specific
            requirements across all product categories. In the year 2017, our
            company got the ISO 9001:2015 certificate (Quality Management
            System) for the good quality of the bangles.
          </p>
        </GridItem>
      </GridContainer>
      <hr />
    </div>
  );
}
